import { render, staticRenderFns } from "./SendIcon.vue?vue&type=template&id=2c2e77c9&scoped=true"
var script = {}
import style0 from "./SendIcon.vue?vue&type=style&index=0&id=2c2e77c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e77c9",
  null
  
)

export default component.exports